import { AuthType } from './types';
import { UserManager } from 'oidc-client-ts';
import { cognitoAuthConfig } from './cognito/cogitoAuthConfig';

export const getAuthToken = async (): Promise<string | undefined> => {
  const authType: AuthType = import.meta.env.VITE_API_AUTH_STRATEGY;

  switch (authType) {
    case 'cognito': {
      return getCognitoToken();
    }
    case 'local': {
      return getLocalToken();
    }
    default: {
      const type: never = authType;
      throw new Error(`Unsupported auth type found in getAuthToken: ${type}`);
    }
  }
};

export async function getCognitoToken(): Promise<string | undefined> {
  const users = await new UserManager(cognitoAuthConfig).getUser();
  return users?.access_token;
}

export function getLocalToken(): string | undefined {
  return localStorage.getItem('authToken') ?? undefined;
}
